import React from 'react';
import {Stack, Typography, useTheme} from '@mui/material';
import {LinkProps, useNavigate, useRouter} from '@tanstack/react-router';
import {useTranslate} from 'hooks';
import {FontIcon} from 'components';

export type ToPath = LinkProps['to'];

export interface BackButtonProps {
  path?: string | ToPath;
  title?: string;
  showCloseIcon?: boolean;
  navigateBackOnClick?: boolean;
  onClick?: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({
  path,
  title,
  showCloseIcon,
  navigateBackOnClick = false,
  onClick,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const router = useRouter();
  const translate = useTranslate();

  return (
    <button
      data-testid={'back-button'}
      style={{
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        background: 'transparent',
        color: theme.palette.grey['700'],
      }}
      onClick={() => {
        path && navigate({to: path});
        onClick && onClick();
        navigateBackOnClick && router.history.back();
      }}>
      <Stack
        spacing={1}
        direction={'row'}
        sx={{alignItems: 'center', justifyContent: 'center'}}
        aria-label={title ?? translate('common.back')}>
        <FontIcon icon={showCloseIcon ? 'xmark' : 'chevron-left'} size={'sm'} />
        <Typography variant={'body2'} sx={{fontWeight: 'bold', height: 24}}>
          {title ?? translate('common.back')}
        </Typography>
      </Stack>
    </button>
  );
};
